'use strict';

require('../../../modules/es.string.repeat');
var getBuiltInPrototypeMethod = require('../../../internals/get-built-in-prototype-method');
module.exports = getBuiltInPrototypeMethod('String', 'repeat');